import { jsx as a } from "react/jsx-runtime";
import { Icon as e } from "@tameeni/icons";
import { tameeniProductsMap as c } from "../../shared-data/src/lib/products.js";
const p = [
  {
    label: "X",
    url: "https://twitter.com/TameeniKSA",
    icon: /* @__PURE__ */ a(e, { className: "h-6 w-6", name: "XLogo" })
  },
  {
    label: "Facebook",
    url: "https://www.facebook.com/Tameeniksa/",
    icon: /* @__PURE__ */ a(e, { className: "h-6 w-6", name: "Facebook" })
  },
  {
    label: "Instagram",
    url: "https://www.instagram.com/tameeniksa",
    icon: /* @__PURE__ */ a(e, { className: "h-6 w-6", name: "Instagram" })
  },
  {
    label: "Snapchat",
    url: "https://www.snapchat.com/add/tameeniksa",
    icon: /* @__PURE__ */ a(e, { className: "h-6 w-6", name: "Snapchat" })
  },
  {
    label: "YouTube",
    url: "https://www.youtube.com/Tameeniksa",
    icon: /* @__PURE__ */ a(e, { className: "h-6 w-6", name: "Youtube" })
  }
], h = (s, t, l) => Object.entries(c).filter(([n]) => l == null ? void 0 : l.includes(n)).map(([n, m]) => ({
  label: s === "ar" ? m.arabicFullLabel : m.englishFullLabel,
  url: t[n]
})), b = (s, t) => [
  ...t,
  /*   {
    label: footerTranslations.supportLinks[locale].CustomerCareNumber,
    url: 'https://api.whatsapp.com/send?phone=9668002444455',
  }, */
  {
    label: "‪+966 8002 444455‬",
    icon: /* @__PURE__ */ a(e, { width: "16", height: "16", name: "Whatsapp", className: "w-4 h-4" }),
    url: "https://api.whatsapp.com/send?phone=9668002444455"
  }
];
export {
  h as getProductLinks,
  b as getSupportLinks,
  p as socialLinks
};
//# sourceMappingURL=constants.js.map
